/* Clear Mind Club — small progressive enhancements. Everything works without this file. */
(function () {
  document.documentElement.classList.add('cm-js');

  function initBehaviors(root) {
    root.querySelectorAll('[data-cm-behaviors]').forEach(function (list) {
      var section = list.closest('.cm-hero');
      var more = section && section.querySelector('[data-cm-more]');
      // One card open at a time (for browsers without <details name>).
      list.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d.open) return;
        list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
      if (more) {
        more.hidden = false;
        more.addEventListener('click', function () {
          var all = list.classList.toggle('is-all');
          more.setAttribute('aria-expanded', all ? 'true' : 'false');
          more.textContent = all ? more.getAttribute('data-label-less') : more.getAttribute('data-label-more');
          if (!all) {
            list.querySelectorAll('.cm-behavior--extra[open]').forEach(function (o) { o.open = false; });
          }
        });
      }
    });
  }

  function initBuybar(root) {
    var bar = root.querySelector('[data-cm-buybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    // Hide the bar while any real buy button (top or final) or the footer is on screen.
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-cm-buy], [data-cm-buyhide], footer'));
    if (!targets.length) return;
    var seen = new Map();
    targets.forEach(function (t) { seen.set(t, t.hasAttribute('data-cm-buy')); });
    function update() {
      var anyVisible = false;
      seen.forEach(function (v) { if (v) anyVisible = true; });
      var show = !anyVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = bar.querySelector('button');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      update();
    });
    targets.forEach(function (t) { io.observe(t); });
  }

  function initShare(root) {
    root.querySelectorAll('[data-cm-share]').forEach(function (btn) {
      if (btn.dataset.cmReady) return;
      btn.dataset.cmReady = '1';
      if (navigator.share) btn.textContent = 'Share…';
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url'), title = btn.getAttribute('data-title');
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { btn.textContent = btn.getAttribute('data-done'); });
        }
      });
    });
  }

  function init(root) { initBehaviors(root || document); initBuybar(root || document); initShare(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
